import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import AOS from 'aos';
import { filter, Observable, Subscription } from 'rxjs';
import { SystemStatistics } from '../../core/models';
import { Router } from '@angular/router';
import { uniqBy, voucherImage, orderBy } from '../../core/helpers';

@Component({
    selector: 'gs-competitions',
    templateUrl: './competitions.component.html',
    standalone: false
})
export class CompetitionsComponent implements OnInit {
  @Select(state => state.staticData.systemStatistics) systemStatistics$: Observable<SystemStatistics>;

  vouchers: any[];

  private filterOutCategories: number[] = [4];
  private filterInCategories: number[] = [];
  private filterOutPartners: number[] = [73];

  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private store: Store,
  ) {
  }

  ngOnInit() {
    this.loadVouchers();
    setTimeout(() => {
      //Fix AOS not triggering when route animations are enabled
      AOS.refresh();
    }, 500);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onContactClick() {
    this.router.navigate(['/contact'], { queryParams: { subject: 3 } });
  }

  private loadVouchers() {
    this.subscriptions.push(
      this.store.select<any>(state => state.staticData.vouchers)
        .pipe(filter(x => !!x))
        .subscribe(response => {
          // Clone array with objects
          let list: any[] = response.map(x => ({ ...x }));
          // Filter vouchers by category and partner
          list = this.filterVouchers(list);

          // Dedupe by partner
          list = uniqBy(list, 'partnerId');

          // Fix image url
          list.forEach((x) => {
            x.image = voucherImage(x.image)
          });

          // Sort
          this.vouchers = this.sortVouchers(list, 'implicit');
        })
    );
  }


  /**
  * Filter in and out vouchers by categoryId
  *
  * @private
  * @param {any[]} vouchers
  * @returns {any[]}
  * @memberof GiftCardsListComponent
  */
  private filterVouchers(vouchers: any[]): any[] {
    let filteredVoucherList = vouchers;

    // Categories to remove from list
    if (this.filterOutCategories && this.filterOutCategories.length > 0) {
      filteredVoucherList = filteredVoucherList.filter(c => this.filterOutCategories.every(o => o != c.partnerCategories));
    }

    // Categories to keep in list
    if (this.filterInCategories && this.filterInCategories.length > 0) {
      filteredVoucherList = filteredVoucherList.filter(c => this.filterInCategories.some(o => o == c.partnerCategories));
    }

    // Partners to remove from list
    if (this.filterOutPartners && this.filterOutPartners.length > 0) {
      filteredVoucherList = filteredVoucherList.filter(c => this.filterOutPartners.every(o => o != c.partnerId));
    }

    return filteredVoucherList;
  }

  /**
 * Sort vouchers based on selection
 *
 * @private
 * @param {*} list
 * @param {string} sort
 * @returns
 * @memberof GiftCardsListComponent
 */
  private sortVouchers(list: any, sort: string) {
    switch (sort) {
      case 'implicit': {
        return orderBy(list, 'rate');
      }
      case 'za': {
        return orderBy(list, '-partnerName');
      }
      default: {
        return orderBy(list, 'partnerName');
      }
    }
  }
}
